export default __webpack_public_path__ + "static/media/getCouponIllustrator.3f9baa81.svg";